import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import MembersComponent from 'modules/members/components/MembersComponent';
import { fetchMembers } from 'modules/members/actions';
import SnackBar from 'modules/common/components/SnackBar';
import { status } from 'constants/general';
import { searchQueryMinLength } from 'constants/members';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################

const MembersContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const membersList = useSelector(state => state.members.membersList);
  const { addUserStatus, snackBarMessage } = membersList;

  const dispatch = useDispatch();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  const [membersQueryStrings, setMembersQueryStrings] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [isAddMemberModalHidden, setIsAddMemberModalHidden] = useState(true);
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [snackBarMessageType, setSnackBarMessageType] = useState(status.SUCCESS);
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    if (addUserStatus === status.SUCCESS) {
      setIsSnackBarOpen(true);
      setSnackBarMessageType(status.SUCCESS);
    } else if (addUserStatus === status.FAIL) {
      setIsSnackBarOpen(true);
      setSnackBarMessageType(status.FAIL);
    }
  }, [addUserStatus]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleSerachInputChange = (SearchEmail, reset) => {
    const queryString = {
      ...membersQueryStrings,
    };
    if (SearchEmail) queryString.userEmail = SearchEmail;
    if (reset) delete queryString.userEmail;

    setMembersQueryStrings(queryString);

    dispatch(fetchMembers(queryString));
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        handleSerachInputChange(value);
      }, 500);
    }
    // this condition checks if we are deleteing letters from search query and we reached
    // 2 characters, then we need to clear search query filter
    else if (searchQuery.length >= searchQueryMinLength && value.length < searchQueryMinLength)
      handleSerachInputChange(value, true);
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <>
      <SnackBar
        show={isSnackBarOpen}
        onHide={() => {
          setIsSnackBarOpen(false);
        }}
        messageType={snackBarMessageType}
        message={snackBarMessage}
      />
      <MembersComponent
        searchQuery={searchQuery}
        membersList={membersList}
        handleSearchBarInputChange={handleSearchBarInputChange}
        isAddMemberModalHidden={isAddMemberModalHidden}
        setIsAddMemberModalHidden={setIsAddMemberModalHidden}
      />
    </>
  );
};

export default MembersContainer;
